import { IFormThingsToImprove } from 'legacy/lut/classes/models/partner360/IFormThingsToImprove'

import { KeyInitiative } from 'partner360/entities/keyInitiatives'
import {
  ActionsPlanTypes,
  KeyInitiativeInitTypes,
  TInvestmentSourceValue,
} from 'partner360/entities/keyInitiatives/model/types'

interface ICopyScope {
  partnerId: string
  fYear: number
  programType: string | null
}

const investmentSources: Record<string, TInvestmentSourceValue> = {
  Opex: ActionsPlanTypes.Opex,
  MDF: ActionsPlanTypes.MDF,
  DGF: ActionsPlanTypes.DGF,
  'Alliance Funds': 'Alliance Funds',
}

/** Local, read-only plan contribution; never sent to the backend or inserted in the table cache. */
export const buildCopySessionInitiative = (
  source: KeyInitiative,
  changes: Partial<KeyInitiative> | Partial<IFormThingsToImprove>,
  { partnerId, fYear, programType }: ICopyScope
): KeyInitiative => {
  const { HPInvestmentSource, InitType, ...fields } = changes
  const investmentSource =
    HPInvestmentSource === undefined ? source.HPInvestmentSource : HPInvestmentSource
  const initType = InitType === undefined ? source.InitType : InitType

  const copy: KeyInitiative = {
    ...source,
    ...fields,
    // A create response may have no rows. A session-only identity still lets subsequent
    // editors include the saved amounts without reusing the previous year's identity.
    EntryId: changes.EntryId ?? -source.EntryId,
    PreviousEntryId: source.EntryId,
    PartnerId: partnerId,
    FYear: fYear,
    ProgramType: programType,
    HPInvestmentSource: investmentSource ? (investmentSources[investmentSource] ?? null) : null,
    InitType:
      initType === KeyInitiativeInitTypes.ImportedInitiative
        ? KeyInitiativeInitTypes.ImportedInitiative
        : null,
  }

  // A new record does not inherit targets omitted from its save payload (for example
  // when the editor switched ValueType). Count only what was actually saved.
  for (const prefix of ['Goal', 'Incremental'] as const) {
    for (const valueType of ['Ndp', 'Net', 'TNet', 'UTNet'] as const) {
      for (const currency of ['', 'USD', 'LocalCurrency'] as const) {
        const field = `${prefix}${valueType}${currency}` as const
        copy[field] = changes[field] ?? 0
      }
    }
  }
  return copy
}
